import { useCallback } from 'react';
import { atom, useAtom } from 'jotai';
import type { AreaType } from '../../constants/areaType';
import type { LinkType } from '../../constants/linkType';
import { exclude } from '../../utils/array';

type UseMapVisibility = {
  visibleAreaType: AreaType | null;
  visibleLinkTypes: LinkType[];
  isAggregationVisible: boolean;
  setVisibleAreaType: (areaType: AreaType | null) => void;
  setVisibleLinkTypes: (linkTypes: LinkType[]) => void;
  toggleVisibleLinkType: (linkType: LinkType) => void;
  setIsAggregationVisible: (isVisible: boolean) => void;
};

const visibleAreaTypeAtom = atom<AreaType | null>('town');

const visibleLinkTypesAtom = atom<LinkType[]>([]);

const isAggregationVisibleAtom = atom<boolean>(true);

const useMapVisibility = (): UseMapVisibility => {
  const [visibleAreaType, setVisibleAreaType] = useAtom(visibleAreaTypeAtom);
  const [visibleLinkTypes, setVisibleLinkTypes] = useAtom(visibleLinkTypesAtom);
  const [isAggregationVisible, setIsAggregationVisible] = useAtom(
    isAggregationVisibleAtom
  );

  const toggleVisibleLinkType = useCallback(
    (linkType: LinkType) => {
      setVisibleLinkTypes((currentLinkTypes: LinkType[]): LinkType[] => {
        if (currentLinkTypes.includes(linkType)) {
          return exclude(currentLinkTypes, linkType);
        } else {
          return [...currentLinkTypes, linkType];
        }
      });
    },
    [setVisibleLinkTypes]
  );

  return {
    visibleAreaType,
    visibleLinkTypes,
    isAggregationVisible,
    setVisibleAreaType,
    setVisibleLinkTypes,
    toggleVisibleLinkType,
    setIsAggregationVisible,
  };
};

export { useMapVisibility };
